export default __webpack_public_path__ + "static/media/rotor-solution-front.6d703767.svg";